module.exports = __webpack_public_path__ + "static/media/Soldia.77c98d43.png";